import ContentImage from '~components/ContentImage/ContentImage';
import ContentImageMobile from '~components/ContentImage/ContentImageMobile';
import { prefixImageLink } from '~globals/common';

type Props = {
    className?: string;
    heroimagemobile: string;
    heroimagetablet: string;
    heroimagedesktop: string;
};

const HeroImage = ({
    className = '',
    heroimagemobile,
    heroimagetablet,
    heroimagedesktop,
}: Props) => {
    const modMobileImage = prefixImageLink(heroimagemobile);
    const modTabletImage = prefixImageLink(heroimagetablet);
    const modDesktopImage = prefixImageLink(heroimagedesktop);

    return (
        <>
            <div className="md:hidden">
                <ContentImageMobile
                    src={modMobileImage}
                    loading="eager"
                    alt="Health benefits your employees will love"
                    className={className}
                />
            </div>
            <div className="hidden md:block lg:hidden">
                <ContentImage
                    src={modTabletImage}
                    loading="eager"
                    alt="Health benefits your employees will love"
                    className={className}
                />
            </div>
            <div className="hidden lg:block">
                <ContentImage
                    src={modDesktopImage}
                    loading="eager"
                    alt="Health benefits your employees will love"
                    className={className}
                />
            </div>
        </>
    );
};

export default HeroImage;
